import axios from 'axios';
import { getItem } from '../../utility/localStorageControl';
import store from '../../redux/store';
import authActions from '../../redux/authentication/actions';
import { API_ENDPOINT } from '../config';


const authHeader = () => ({
  Authorization: `Bearer ${getItem('access_token')}`,
});

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    Authorization: `Bearer ${getItem('access_token')}`,
    'Content-Type': 'application/json',
  },
});

class DataService {
  // login: Cookies.get('logedIn'),

  static get(path = '') {
    return client({
      method: 'GET',
      url: path,
      headers: { ...authHeader() },
    });
  }

  static post(path = '', data = {}, optionalHeader = {}) {
    return client({
      method: 'POST',
      url: path,
      data,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static patch(path = '', data = {}) {
    return client({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static put(path = '', data = {}) {
    return client({
      method: 'PUT',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
// client.interceptors.request.use((config) => {
//   // do something before executing the request
//   // For example tag along the bearer access token to request header or set a cookie
//   const requestConfig = config;
//   const { headers } = config;
//   requestConfig.headers = { ...headers, Authorization: `Bearer ${getItem('access_token')}` };

//   return requestConfig;
// });

// client.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     /**
//      * Do something in case the response returns an error code [3**, 4**, 5**] etc
//      * For example, on token expiration retrieve a new access token, retry a failed request etc
//      */
//     const { response } = error;
//     const originalRequest = error.config;
//     if (response) {
//       if (response.status === 500) {
//         // do something here
//       } else {
//         return originalRequest;
//       }
//     }
//     return Promise.reject(error);
//   },
// );

client.interceptors.response.use(
  (response) => {
    // Check if the response status is 200
    if (response.status === 200) {
      // Check if the `code` key exists in the response data and equals 1001
      if (response.data && response.data.code && Number(response.data.code) === 1001) {
        // Dispatch the logout action
        store.dispatch(authActions.logoutSuccess()); // Adjust this to your logout action
      }
    }
    return response;
  },
  (error) => {
    /**
     * Handle non-200 responses
     */
    return Promise.reject(error);
    // const { response } = error;
    // const originalRequest = error.config;
    // console.log('error_1', error)

    // if (response) {
    //   if (response.status === 500) {
    //     // Handle 500 status code
    //   } else {
    //     return originalRequest;
    //   }
    // }

    // return Promise.reject(error);
  },
);

// Add request interceptor to dynamically update baseURL
client.interceptors.request.use((config) => {
  const user = store.getState()?.auth?.data; // Check if user exists in Redux store
  const requestConfig = { ...config };

  if (user) {
    // If user exists, modify the baseURL dynamically
    requestConfig.baseURL = `${requestConfig.baseURL}/${user.api_url}`; // Replace with the desired user-specific baseURL
  } else {
    // Use the default baseURL
    requestConfig.baseURL = API_ENDPOINT;
  }

  return requestConfig;
}, (error) => {
  // Handle request errors
  return Promise.reject(error);
});

export { DataService };
